// eslint-disable-next-line
export default {
    name: "Carts",
    status: {
        router: true,
        redux: true
    }
}
